import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from './Modal';

interface SendMessageModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSend: (message: string) => void;
  clientName?: string;
  loading?: boolean;
}

const SendMessageModal: React.FC<SendMessageModalProps> = ({
  isOpen,
  onClose,
  onSend,
  clientName,
  loading = false
}) => {
  const { t } = useTranslation();
  const [message, setMessage] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (message.trim()) {
      onSend(message.trim());
    }
  };

  const handleClose = () => {
    setMessage('');
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} title={t('modals.sendMessage.title')}>
      <form onSubmit={handleSubmit} className="modal-form">
        {clientName && (
          <div style={{ marginBottom: '1rem', padding: '1rem', backgroundColor: '#f8f9fa', borderRadius: '5px' }}>
            <strong>{t('modals.sendMessage.client')}:</strong> {clientName}
          </div>
        )}

        <div className="modal-form-group">
          <label htmlFor="message">{t('modals.sendMessage.messageLabel')}</label>
          <textarea
            id="message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder={t('modals.sendMessage.messagePlaceholder')}
            required
            disabled={loading}
            rows={4}
          />
        </div>

        <div className="modal-actions">
          <button
            type="button"
            onClick={handleClose}
            className="modal-button secondary"
            disabled={loading}
          >
            {t('modals.sendMessage.cancel')}
          </button>
          <button
            type="submit"
            className="modal-button primary"
            disabled={loading || !message.trim()}
          >
            {loading ? t('modals.sendMessage.sending') : t('modals.sendMessage.send')}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default SendMessageModal;
